/**
 * Merge media rows and comment rows into a single chronological feed (oldest first).
 * @param {Array} mediaList
 * @param {Array} commentsList
 * @returns {Array<{ kind: 'file'|'comment', occurredAt: string, sortKey: number, data: object }>}
 */
export function buildWorkspaceFeed(mediaList = [], commentsList = []) {
  const items = [];

  (mediaList || []).forEach((m) => {
    const t = m.created_at ? new Date(m.created_at).getTime() : 0;
    items.push({
      kind: 'file',
      occurredAt: m.created_at,
      sortKey: t,
      data: m,
    });
  });

  (commentsList || []).forEach((c) => {
    const t = c.created_at ? new Date(c.created_at).getTime() : 0;
    items.push({
      kind: 'comment',
      occurredAt: c.created_at,
      sortKey: t,
      data: c,
    });
  });

  items.sort((a, b) => a.sortKey - b.sortKey);
  return items;
}

/**
 * Map server-assembled portal feed rows to the same feed item shape.
 * @param {Array<{ kind: string, occurred_at?: string, item: object }>} rows
 */
export function mapPortalFeedRows(rows = []) {
  return (rows || []).map((row) => {
    const kind = row.kind === 'workspace_event' ? 'workspace_event' : row.kind === 'file' ? 'file' : 'comment';
    return {
      kind,
      occurredAt: row.occurred_at,
      sortKey: row.occurred_at ? new Date(row.occurred_at).getTime() : 0,
      data: row.item,
    };
  });
}
